import React from "react";

import { useQuery } from "@apollo/client/react/hooks";

import { OrderByDirection } from "@/gql/graphql";
import { formatISODate } from "@/utils/datetime";

import { ClientList } from "./ClientList";
import { weightLoggingClientsQuery } from "../graphql/dashboardPageQueries";

export const WeightLoggingTab: React.FC = () => {
  const { data, loading, refetch } = useQuery(weightLoggingClientsQuery, {
    variables: {
      currentDate: formatISODate(new Date()),
      orderByName: OrderByDirection.Asc,
      statuses: ["active", "struggling", "inactive"],
    },
  });

  return (
    <ClientList
      isLoading={loading}
      tab="weightLogging"
      clients={data?.weightLoggingClients.nodes ?? []}
      onSort={(sortBy) => refetch({ orderByName: sortBy })}
      onSearch={(searchKey) => refetch({ searchKey })}
      onFilterStatus={(statuses: string[]) => refetch({ statuses })}
    />
  );
};
